<template>
  <div class="about">
    <h1>A site for events</h1>
  </div>
</template>
